<alert type="info">
  <!-- <a href="https://www.boe.ca.gov/prop19/" target="_blank">
    <alert type="info">
      {{ "Prop19.Prop19Infov2" | translate }}
    </alert>

  </a> -->
  <p [innerHTML]="'DisabledVeterans.DVXNoticeBody2'|translate"></p>
</alert>
<app-leveltwo [videos]="true" [pageName]="'Disabled Veterans Property Tax Exemption'">
    <div heading="General Info" class="General">
      <h3>{{'DisabledVeterans.PageTitle'|translate}}</h3>

      <p>{{'DisabledVeterans.Ifyou'|translate}}</p>

      <!-- <i><p [innerHTML]="'DisabledVeterans.FurtherInstructions'|translate"></p></i> -->
      <b><p [innerHTML]="'DisabledVeterans.Ifyouareeligible'|translate"></p></b>
      <b>Los Angeles County Assessor's Office</b><br>
      500 W. Temple St. Room 227<br>
      Los Angeles, CA 90012<br><br>

      <p [innerHTML]="'DisabledVeterans.Forthesecurity'|translate"></p>

      <div class="vet-info">
        <p [innerHTML]="'DisabledVeterans.Formorev2'|translate"></p>
      </div>
      <br>
      <br>
      <section class="accordion">
        <div class="tab">
          <input type="checkbox" name="accordion-1" id="cb1" unchecked>
          <label for="cb1" class="tab__label">Click to view Disabled Veteran Exemption (Standard) and Low Income Disabled Veteran Exemption with Household Income Limits for Current and Prior Years</label>
          <div class="tab__content">
            <table>
              <tr>
                <th>LIEN DATE</th>
                <th>FACTOR</th>
                <th>STANDARD EXEMPTION</th>
                <th>LOW-INCOME EXEMPTION</th>
                <th>INCOME LIMIT</th>

              </tr>
              <tr>
                <td>2025</td>
                <td>1.03257</td>
                <td>$175,298</td>
                <td>$262,950</td>
                <td>$78,718</td>
              </tr>
              <tr>
                <td>2024</td>
                <td>1.05392</td>
                <td>$169,769</td>
                <td>$237,656</td>
                <td>$76,235</td>
              </tr>
              <tr>
                <td>2023</td>
                <td>1.07394</td>
                <td>$161,083</td>
                <td>$241,627</td>
                <td>$72,335</td>
              </tr>
              <tr>
                <td>2022</td>
                <td>1.01666</td>
                <td>$149,993</td>
                <td>$224,991</td>
                <td>$67,355</td>
              </tr>
              <tr>
                <td>2021</td>
                <td>1.02975</td>
                <td>$147,535</td>
                <td>$221,304</td>
                <td>$66,251</td>
              </tr>
              <tr>
                <td>2020</td>
                <td>1.02751</td>
                <td>$143,273</td>
                <td>$214,910</td>
                <td>$64,337</td>
              </tr>


            </table>
          </div>
        </div>

      </section>


      <!-- <div class="accordion" >
        <accordion [isAnimated]="true" >
        <accordion-group #drop [isOpen]="true">
          <div accordion-heading style="max-width: 50%;">
            <span class="dropdown-item clearfix">

                  {{'DisabledVeterans.ClicktoView'|translate}}

                  <i class="mt-1 float-end" [ngClass]="!drop.isOpen ? 'fas fa-plus' : 'fas fa-minus'"></i>


            </span>
          </div>

          <table>
            <tr>
              <th>LIEN DATE</th>
              <th>FACTOR</th>
              <th>STANDARD EXEMPTION</th>
              <th>LOW-INCOME EXEMPTION</th>
              <th>INCOME LIMIT</th>

            </tr>
            <tr>
              <td>2024</td>
              <td>1.05392</td>
              <td>$169,769</td>
              <td>$237,656</td>
              <td>$76,235</td>
            </tr>
            <tr>
              <td>2023</td>
              <td>1.07394</td>
              <td>$161,083</td>
              <td>$241,627</td>
              <td>$72,335</td>
            </tr>
            <tr>
              <td>2022</td>
              <td>1.01666</td>
              <td>$149,993</td>
              <td>$224,991</td>
              <td>$67,355</td>
            </tr>
            <tr>
              <td>2021</td>
              <td>1.02975</td>
              <td>$147,535</td>
              <td>$221,304</td>
              <td>$66,251</td>
            </tr>
            <tr>
              <td>2020</td>
              <td>1.02751</td>
              <td>$143,273</td>
              <td>$214,910</td>
              <td>$64,337</td>
            </tr>


          </table>

        </accordion-group>
        </accordion>
      </div> -->


    </div>

  <app-videos-grid class="Videos" [videos]="videos"></app-videos-grid>

    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
